module.exports = __webpack_public_path__ + "img/157.802cdd0d.jpg";